const frenchDate = (date: string) => {
  return new Date(date).toLocaleDateString('fr-FR');
};

export default frenchDate;
